export enum ChainId {
  EthereumMainnet = 1,
  PoaNetworkSokol = 77,
  PoaNetworkCore = 99,
  PolygonMainnet = 137,
}
